import {
  dateFormat,
  dateTimeFormat,
  dateAndTimeFormat,
  dayTime,
  dateTextFormat,
  dayMonthFormat,
  dayFormat,
  monthYearFormat,
  timeFormat,
  yearFormat,
  monthFormat,
  fileNameFormat,
  noDataDefault,
} from '@/filters/DateFilters';
import {
  addressFormat,
  bankAccountFormat,
  capitalize,
  decimalFormat,
  displayName,
  mortgageSimulationPurposeTitle,
  numeralFormat,
  peselFormat,
  phoneFormat,
  phoneFormatCustom,
  subString,
  trimString,
  zipCodeFormat,
} from '@/filters/StringFilters';
import { bankName, districtName, landName, productType } from '@/filters/DictionaryFilters';

/**
 * Shared formatters (replaces legacy Vue template filters).
 * Pure functions — safe outside setup; spread into `methods`, or import named exports in `<script setup>`.
 * `numeralFormat` / `decimalFormat` come from StringFilters (canonical).
 */
export const useFilters = () => ({
  capitalize,
  dateTimeFormat,
  dateAndTimeFormat,
  dayTime,
  /** @deprecated alias of dateTextFormat — kept for parity with former Vue filter name */
  fullDateTime: dateTextFormat,
  dateTextFormat,
  dayMonthFormat,
  dayFormat,
  dateFormat,
  monthYearFormat,
  timeFormat,
  trimString,
  subString,
  yearFormat,
  monthFormat,
  fileNameFormat,
  decimalFormat,
  numeralFormat,
  addressFormat,
  zipCodeFormat,
  bankAccountFormat,
  peselFormat,
  mortgageSimulationPurposeTitle,
  noDataDefault,
  phoneFormat,
  phoneFormatCustom,
  landName,
  districtName,
  bankName,
  productType,
  displayName,
});

export type FiltersApi = ReturnType<typeof useFilters>;

/** Alias of dateTextFormat — former Vue filter name */
export const fullDateTime = dateTextFormat;

export {
  capitalize,
  dateTimeFormat,
  dateAndTimeFormat,
  dayTime,
  dateTextFormat,
  dayMonthFormat,
  dayFormat,
  dateFormat,
  monthYearFormat,
  timeFormat,
  trimString,
  subString,
  yearFormat,
  monthFormat,
  fileNameFormat,
  decimalFormat,
  numeralFormat,
  addressFormat,
  zipCodeFormat,
  bankAccountFormat,
  peselFormat,
  mortgageSimulationPurposeTitle,
  noDataDefault,
  phoneFormat,
  phoneFormatCustom,
  landName,
  districtName,
  bankName,
  productType,
  displayName,
};
